module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ursa_major/uma_vis-69da05baf991d61ddd622477ecd38242.jpg";